<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2023-08-24 16:05:41
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-09-06 17:36:43
-->
<template>
	<div>
		<slot></slot>
	</div>
</template>
<script>
export default {
	props: {
		list: {
			type: Array,
			default: () => [],
		},
	},
};
</script>